function generatePC(width, height, Illu, unit,media) {
    let area = 1;
    let multiplier = 1;
    
    if(unit){
        area *= unit;
    }

    if(Illu === "B/L"){
        Illu = "BL"
    }
    else if(Illu === "F/L"){
        Illu = "FL"
    }
    else if(Illu === "N/L"){
        Illu = "NL"
    }
    
    if(media==="Kiosk"){
        switch (Illu) {
            case "BL":
                multiplier = 500;
                break;
            case "NL":
                multiplier = 250;
                break;
        }
    }else{
        area *= width * height ;
        switch (Illu) {
            case "BL":
                multiplier = 20;
                break;
            case "FL":
                multiplier = 10;
                break;
            case "NL":
                multiplier = 10;
                break;
        }
    }
    

    return area * multiplier;
}
export default generatePC